import { render, staticRenderFns } from "./SalesSetting.vue?vue&type=template&id=b8db827a&scoped=true"
import script from "./SalesSetting.vue?vue&type=script&lang=js"
export * from "./SalesSetting.vue?vue&type=script&lang=js"
import style0 from "./SalesSetting.vue?vue&type=style&index=0&id=b8db827a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8db827a",
  null
  
)

export default component.exports